export enum MessageRecipientTypeEnum {
  ALL = 'all',
  SUBSCRIBERS = 'subscribers',
  NON_SUBSCRIBERS = 'non_subscribers',
  INACTIVE_SUBSCRIBERS = 'inactive_subscribers',
  DOWNSELL = 'downsell',
  RECURRENT = 'recurrent',
  UPSELLERS = 'upsellers',
  DOWNSELLERS = 'downsellers',
  PACKAGES = 'packages',
  ABANDONED_PIX = 'abandoned_pix',
  CHAT_JOIN_REQUEST_APPROVAL = 'chat_join_request_approval',
  FLOW_NODE = 'flow_node',
  FLOW_CURRENT_NODE = 'flow_current_node',
}

export const MessageRecipientTypeLabels = {
  [MessageRecipientTypeEnum.ALL]: 'Todos',
  [MessageRecipientTypeEnum.SUBSCRIBERS]: 'Assinantes',
  [MessageRecipientTypeEnum.NON_SUBSCRIBERS]: 'Não assinantes',
  [MessageRecipientTypeEnum.INACTIVE_SUBSCRIBERS]: 'Assinantes inativos (compraram, mas não renovaram)',
  [MessageRecipientTypeEnum.RECURRENT]: 'Leads recorrentes (compraram mais de uma vez)',
  [MessageRecipientTypeEnum.ABANDONED_PIX]: 'Leads que geraram pix e não pagaram',
  [MessageRecipientTypeEnum.DOWNSELL]: 'Downsell',
  [MessageRecipientTypeEnum.UPSELLERS]: 'Leads upsellers (compraram upsell)',
  [MessageRecipientTypeEnum.DOWNSELLERS]: 'Leads downsellers (compraram downsell)',
  [MessageRecipientTypeEnum.PACKAGES]: 'Leads que compraram packs',
  [MessageRecipientTypeEnum.CHAT_JOIN_REQUEST_APPROVAL]: 'Leads que pediram para se juntar ao grupo ou canal',
  [MessageRecipientTypeEnum.FLOW_NODE]: 'Leads que passaram pelo nó',
  [MessageRecipientTypeEnum.FLOW_CURRENT_NODE]: 'Leads que estão no nó',
}